import React from 'react';
import { Mail } from 'lucide-react';

export default function LegalNoticePage() {
  return (
    <div className="min-h-screen py-12 px-4" style={{ backgroundColor: '#FDFBF7' }}>
      <div className="max-w-4xl mx-auto">
        <article className="prose prose-lg max-w-none">
          <h1 className="font-serif text-4xl md:text-5xl font-bold text-primary mb-8" style={{ color: '#2C3E50' }}>
            Aviso Legal
          </h1>

          {/* Section 1 */}
          <section className="mb-10">
            <h2 className="font-serif text-2xl font-semibold text-primary mb-4" style={{ color: '#2C3E50' }}>
              1. Datos identificativos
            </h2>
            <p className="text-secondary mb-4" style={{ color: '#5D6D7E' }}>
              En cumplimiento de lo dispuesto en la Ley 34/2002, de Servicios de la Sociedad de la Información y de Comercio Electrónico (LSSI-CE), se informa a los usuarios de los siguientes datos del titular de este sitio web:
            </p>
            <div className="bg-white rounded-xl p-6 shadow-sm border border-gray-100">
              <p className="text-secondary" style={{ color: '#5D6D7E' }}><strong>Titular:</strong> Pier Andrea Saraco</p>
              <p className="text-secondary" style={{ color: '#5D6D7E' }}><strong>NIE:</strong> Y5378093V</p>
              <p className="text-secondary" style={{ color: '#5D6D7E' }}><strong>Dirección:</strong> Avenida Juan Carlos I 33, Los Cristianos, Arona, Santa Cruz de Tenerife, España</p>
              <p className="text-secondary" style={{ color: '#5D6D7E' }}>
                <strong>Correo electrónico:</strong> <a href="mailto:info@tantra-map.com" className="text-gold hover:underline" style={{ color: '#D4A574' }}>info@tantra-map.com</a>
              </p>
              <p className="text-secondary" style={{ color: '#5D6D7E' }}>
                <strong>Sitio web:</strong> <a href="https://tantra-map.com" target="_blank" rel="noopener noreferrer" className="text-gold hover:underline" style={{ color: '#D4A574' }}>https://tantra-map.com</a>
              </p>
            </div>
          </section>

          {/* Section 2 */}
          <section className="mb-10">
            <h2 className="font-serif text-2xl font-semibold text-primary mb-4" style={{ color: '#2C3E50' }}>
              2. Objeto del sitio web
            </h2>
            <p className="text-secondary mb-4" style={{ color: '#5D6D7E' }}>
              El sitio web <strong>tantra-map.com</strong> es una plataforma digital que ofrece un <strong>directorio de profesionales y escuelas relacionadas con el tantra</strong>.
            </p>
            <p className="text-secondary mb-4" style={{ color: '#5D6D7E' }}>
              La finalidad del sitio es facilitar a los usuarios la búsqueda de información y el contacto directo con profesionales del sector.
            </p>
            <p className="text-secondary" style={{ color: '#5D6D7E' }}>
              La plataforma actúa exclusivamente como <strong>herramienta informativa y de visibilidad profesional</strong>, sin intervenir en la prestación de los servicios ofrecidos por terceros.
            </p>
          </section>

          {/* Section 3 */}
          <section className="mb-10">
            <h2 className="font-serif text-2xl font-semibold text-primary mb-4" style={{ color: '#2C3E50' }}>
              3. Condiciones de acceso
            </h2>
            <p className="text-secondary mb-4" style={{ color: '#5D6D7E' }}>
              El acceso al sitio web es libre y gratuito.
            </p>
            <p className="text-secondary mb-4" style={{ color: '#5D6D7E' }}>
              El usuario se compromete a utilizar el sitio web de forma adecuada, conforme a la legislación vigente, la buena fe y el orden público.
            </p>
            <p className="text-secondary mb-2" style={{ color: '#5D6D7E' }}>
              Queda prohibido:
            </p>
            <ul className="list-disc pl-6 text-secondary space-y-2 mb-4" style={{ color: '#5D6D7E' }}>
              <li>utilizar el sitio web con fines ilegales</li>
              <li>introducir virus o elementos informáticos dañinos</li>
              <li>intentar acceder sin autorización a sistemas informáticos del sitio</li>
              <li>utilizar la plataforma para actividades fraudulentas</li>
            </ul>
            <p className="text-secondary" style={{ color: '#5D6D7E' }}>
              El titular podrá bloquear el acceso a usuarios que incumplan estas condiciones.
            </p>
          </section>

          {/* Section 4 */}
          <section className="mb-10">
            <h2 className="font-serif text-2xl font-semibold text-primary mb-4" style={{ color: '#2C3E50' }}>
              4. Propiedad intelectual
            </h2>
            <p className="text-secondary mb-4" style={{ color: '#5D6D7E' }}>
              Todos los contenidos del sitio web (textos, estructura, diseño, software, logotipos y elementos gráficos) están protegidos por derechos de propiedad intelectual.
            </p>
            <p className="text-secondary" style={{ color: '#5D6D7E' }}>
              Queda prohibida su reproducción, distribución o modificación sin autorización expresa del titular.
            </p>
          </section>

          {/* Section 5 */}
          <section className="mb-10">
            <h2 className="font-serif text-2xl font-semibold text-primary mb-4" style={{ color: '#2C3E50' }}>
              5. Enlaces externos
            </h2>
            <p className="text-secondary mb-4" style={{ color: '#5D6D7E' }}>
              El sitio web puede contener enlaces a páginas web de terceros.
            </p>
            <p className="text-secondary" style={{ color: '#5D6D7E' }}>
              El titular no se responsabiliza del contenido, políticas de privacidad o prácticas de dichos sitios externos.
            </p>
          </section>

          {/* Section 6 */}
          <section className="mb-10">
            <h2 className="font-serif text-2xl font-semibold text-primary mb-4" style={{ color: '#2C3E50' }}>
              6. Legislación aplicable
            </h2>
            <p className="text-secondary mb-4" style={{ color: '#5D6D7E' }}>
              Las relaciones entre el usuario y el titular se regirán por la legislación española vigente.
            </p>
            <p className="text-secondary" style={{ color: '#5D6D7E' }}>
              Cualquier conflicto será sometido a los tribunales competentes de España.
            </p>
          </section>

        </article>
      </div>
    </div>
  );
}
